import { api } from '../state/auth.js';

// Unreleased features this user may see (see services/features.js). Cached per user
// and club; a failed request hides them.
const cache = new Map();
export async function fetchFeatures(key) {
  if (cache.has(key)) return cache.get(key);
  let features = {};
  try { features = await api('/api/features'); } catch { /* hidden */ }
  cache.set(key, features);
  return features;
}
